import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import './styles.css'

const container = document.getElementById('root')
if (!container) throw new Error('Не найден элемент #root')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Service worker кеширует только оболочку приложения (см. public/sw.js).
// В деве не регистрируем: иначе кеш перекрывает горячую перезагрузку Vite.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js')
  })
}
